import { AnyDocument, WorkflowState } from '../../../types';
import { Entity } from '../../../types/utility';
import { InceptHeader } from '../../constants/InceptHeader';
import { buildIncludeParams } from '../../logic/buildIncludeParams';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { DOCUMENTS_BASE_PATH } from '../constants/documentsBasePath';

export const postCreateDocument = async (
  constructPost: ConstructPost,
  definitionName: string,
  workflowName: string | undefined,
  data: Entity,
  includes?: string[],
): Promise<NonPaginatedResponse<AnyDocument, WorkflowState> | undefined> =>
  constructPost(
    DOCUMENTS_BASE_PATH,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
        ...(workflowName ? { [InceptHeader.WorkflowName]: workflowName } : {}),
      },
      params: buildIncludeParams(includes),
    },
    { preventDefaultErrorToast: true },
  );
